<template>
    <div>
        <Header title="测评设备" memo="管理注意力测评设备信息"></Header>
        <a-divider />
        <div class="flex-x-space-between" :style="{ marginTop: '16px' }">
            <div>
                <a-button type="danger" icon="delete" @click="execDelete" :style="{ marginRight: '8px' }" :disabled="selRows.length === 0">
                    删除
                </a-button>
            </div>
            <div>
                <a-form-model layout="inline" :model="query">
                    <a-form-model-item>
                        <a-select show-search v-model="query.unit" :filter-option="false" :not-found-content="null" @search="doLoadUnit" @change="execQuery" :style="{ width: '200px' }">
                            <a-select-option value="">
                                所有机构
                            </a-select-option>
                            <a-select-option v-for="item in units" :key="item.id" :value="item.id" :label="item.name">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-select v-model="query.state" @change="execQuery" :style="{ width: '200px' }">
                            <a-select-option value="">
                                所有设备
                            </a-select-option>
                            <a-select-option value="Pass">
                                已通过
                            </a-select-option>
                            <a-select-option value="Reject">
                                未通过
                            </a-select-option>
                            <a-select-option value="Wait">
                                未审核
                            </a-select-option>
                            <a-select-option value="NoBind">
                                未绑定
                            </a-select-option>
                            <a-select-option value="Use">
                                使用中
                            </a-select-option>
                            <a-select-option value="Idle">
                                空闲中
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="search" @click="execQuery">
                            查询
                        </a-button>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="retweet" @click="execReload">
                            刷新
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </div>
        <a-divider />
        <a-table :style="{ marginTop: '16px' }" :row-key="record => record.id" :data-source="datas" :loading="loading" :row-selection="{ type: 'checkbox', onChange: onSelectChange }" bordered :pagination="false">
            <a-table-column data-index="code" ellipsis width="300px">
                <span slot="title">设备标识</span>
                <template slot-scope="text, record">
                    <a-tag color="#2db7f5">
                        {{ record.sno }}
                    </a-tag>
                    {{ record.name }}
                    <a-popover placement="top" trigger="click">
                        <template slot="content">
                            <a-form-model layout="inline">
                                <a-form-model-item>
                                    <a-input v-model="editName" :placeholder="record.name">
                                        <a-icon slot="prefix" type="book" style="color:rgba(0,0,0,.25)" />
                                    </a-input>
                                </a-form-model-item>
                                <a-form-model-item>
                                    <a-button icon="save" @click="doEditName(record.id)">
                                        修改名称
                                    </a-button>
                                </a-form-model-item>
                            </a-form-model>
                        </template>
                        <template slot="title">
                            <span>修改设备名称</span>
                        </template>
                        <a-icon type="edit" style="color: green" />
                    </a-popover>
                </template>
            </a-table-column>
            <a-table-column data-index="info" ellipsis>
                <span slot="title">设备信息</span>
                <template slot-scope="text, record">
                    <a-popover placement="top" trigger="click">
                        <template slot="content">
                            <a-switch checked-children="支持测评" un-checked-children="禁用测评" :default-checked="record.exam" @change="doChangeExam(record)" />
                        </template>

                        <a-tag color="#87d068" v-if="record.exam">
                            支持测评
                        </a-tag>
                        <a-tag color="#ff6666" v-if="!record.exam">
                            禁用测评
                        </a-tag>
                    </a-popover>

                    <a-popover placement="top" trigger="click">
                        <template slot="content">
                            <a-switch checked-children="支持训练" un-checked-children="禁用训练" :default-checked="record.exer" @change="doChangeExer(record)" />
                        </template>

                        <a-tag color="#108ee9" v-if="record.exer">
                            支持训练
                        </a-tag>
                        <a-tag color="#ff6666" v-if="!record.exer">
                            禁用训练
                        </a-tag>
                    </a-popover>

                    <a-popover placement="top" trigger="click">
                        <template slot="content">
                            <a-radio-group :default-value="record.type" button-style="solid" @change="e => doChangeType(record, e)">
                                <a-radio-button value="Unit">
                                    机构类型
                                </a-radio-button>
                                <a-radio-button value="Home">
                                    家庭类型
                                </a-radio-button>
                                <a-radio-button value="Both">
                                    兼容类型
                                </a-radio-button>
                            </a-radio-group>
                        </template>
                        <template slot="title">
                            修改类型
                        </template>
                        <a-tag color="#009999" v-if="record.type === 'Unit'">
                            机构类型
                        </a-tag>
                        <a-tag color="#663300" v-if="record.type === 'Home'">
                            家庭类型
                        </a-tag>
                        <a-tag color="#CC7160" v-if="record.type === 'Both'">
                            兼容类型
                        </a-tag>
                    </a-popover>
                </template>
            </a-table-column>
            <a-table-column data-index="state" ellipsis width="150px">
                <span slot="title">设备状态</span>
                <template slot-scope="text, record">
                    <div v-if="record.audit.state === 'Pass'">
                        <a-popover placement="top" v-if="record.state === 'Use'">
                            <template slot="content">
                                <p>
                                    用户：
                                    <span>{{ record.use.id }}</span>
                                </p>
                                <p>
                                    名称：
                                    <span>{{ record.use.name }}</span>
                                </p>
                            </template>
                            <template slot="title">
                                <span>使用详情</span>
                            </template>
                            <span style="color:tomato;">使用中</span>
                            <a-popconfirm title="是否解除绑定设备？" @confirm="doUnbindDevice(record.use.id, record.id)">
                                <a-icon slot="icon" type="question-circle-o" style="color: red" />

                                <a-button type="link" style="color: red" icon="delete"></a-button>
                            </a-popconfirm>
                        </a-popover>
                        <a-tag color="#2db7f5" v-if="record.state === 'Idle'">{{ record.unit.id ? '空闲中' : '未绑定机构' }}</a-tag>
                    </div>
                    <div v-else>
                        <a-button size="small" v-if="record.audit.state === 'Wait'" @click="showAuditForm(record)">
                            审核设备
                        </a-button>
                        <a-popover placement="top" v-else>
                            <template slot="content">
                                <p>
                                    人员：
                                    <span>{{ record.audit.name }}</span>
                                </p>
                                <p>
                                    时间：
                                    <span>{{ record.audit.time }}</span>
                                </p>
                                <p>
                                    说明：
                                    <span>{{ record.audit.memo }}</span>
                                </p>
                            </template>
                            <template slot="title">
                                <span>审核详情</span>
                            </template>
                            <span style="color:tomato;">未通过</span>
                        </a-popover>
                    </div>
                </template>
            </a-table-column>
            <a-table-column data-index="unit" ellipsis width="180px">
                <span slot="title">归属机构</span>
                <template slot-scope="text, record">
                    <template v-if="record.audit.state === 'Pass'">
                        <a-popover placement="top" trigger="click" v-if="!record.unit.id">
                            <template slot="content">
                                <a-form-model layout="inline">
                                    <a-form-model-item>
                                        <a-select show-search v-model="bindUnit" :filter-option="false" :not-found-content="null" @search="doLoadUnit" :style="{ width: '200px' }">
                                            <a-select-option v-for="item in units" :key="item.id" :value="item.id" :label="item.name">
                                                {{ item.name }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-model-item>
                                    <a-form-model-item>
                                        <a-button icon="link" @click="doBindUnit(record.id)">
                                            提交绑定
                                        </a-button>
                                    </a-form-model-item>
                                </a-form-model>
                            </template>
                            <template slot="title">
                                <span>选择机构进行绑定</span>
                            </template>
                            <a-button size="small">绑定机构</a-button>
                        </a-popover>
                        <template v-else>
                            {{ record.unit.name }}
                            <a-popconfirm title="是否解除绑定机构？" @confirm="doUnbindUnit(record.id, record.unit.id)">
                                <a-icon slot="icon" type="question-circle-o" style="color: red" />
                                <a-icon type="delete" style="color: red" />
                            </a-popconfirm>
                        </template>
                    </template>
                    <template v-else>
                        尚未审核
                    </template>
                </template>
            </a-table-column>
            <a-table-column data-index="last" ellipsis width="180px">
                <span slot="title">最近测评</span>
                <template slot-scope="text, record">
                    {{ record.last.time || '尚未测评' }}
                </template>
            </a-table-column>
        </a-table>
        <a-pagination
            :style="{ marginTop: '15px' }"
            :total="pager.rows"
            :current="query.page"
            :show-total="total => `共计 ${total} 条数据`"
            show-quick-jumper
            show-less-items
            show-size-changer
            hide-on-single-page
            :page-size.sync="query.size"
            :page-size-options="['10', '25', '50', '100']"
            @change="onChangePage"
            @showSizeChange="onChangeSize"
        />

        <AuditComp title="审核设备" :item="now" :show.sync="form" v-if="form" @doLoad="doLoad"></AuditComp>
    </div>
</template>

<script>
import AuditComp from './AuditComp'

export default {
    name: 'AtePlatDevice',
    components: {
        AuditComp
    },
    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        },
        rowSelection() {
            return {
                onChange: this.onSelectRows
            }
        }
    },
    data() {
        return {
            units: [],
            query: {
                page: 1,
                size: 10,
                time: 0,
                unit: '',
                state: ''
            },
            selRows: [],
            datas: [],
            pager: {
                rows: 0,
                pnum: 1,
                pnow: 1,
                time: 0
            },
            view: false,
            form: false,
            now: {},
            bindUnit: '',
            editName: ''
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['云测评', '测评设备'])
        this.doLoadUnit()
        this.doLoad()
    },
    methods: {
        doLoadUnit(name) {
            this.$http
                .get('/sys/data/user/unit', {
                    params: {
                        size: 20,
                        name: name || ''
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.units = result.datas
                })
        },
        doLoad() {
            this.$http
                .get('/cts/ate/device/mgr/list', {
                    params: this.query,
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    if (result.data.pnow === 1) {
                        this.query.time = result.data.time
                    }
                    this.pager = result.data
                    this.datas = result.datas
                })
        },
        doDelete(ids) {
            this.$http
                .post('/cts/ate/device/mgr/delete', {
                    ids: typeof ids === 'string' ? ids : ids.join()
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('删除成功')
                        this.doLoad()
                    }
                })
        },
        doUnbindDevice(tid, did) {
            this.$http
                .post('/cts/ate/device/mgr/tester/set', {
                    tid: tid,
                    id: did,
                    flag: false
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('解绑成功')
                        this.doLoad()
                    }
                })
        },
        doBindUnit(did) {
            if (!this.bindUnit) {
                this.$message.error('请选择要绑定的机构')
                return
            }
            this.$http
                .post('/cts/ate/device/mgr/unit/set', {
                    id: did,
                    unit: this.bindUnit,
                    flag: true
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('绑定成功')
                        this.bindUnit = ''
                        this.doLoad()
                    }
                })
        },
        doEditName(did) {
            if (!this.editName) {
                this.$message.error('请填写新名称')
                return
            }
            this.$http
                .post('/cts/ate/device/mgr/rename', {
                    id: did,
                    name: this.editName
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('修改成功')
                        this.editName = ''
                        this.doLoad()
                    }
                })
        },
        doChangeType(item, e) {
            this.$http
                .post('/cts/ate/device/mgr/type/change', {
                    id: item.id,
                    type: e.target.value
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('变更成功')
                        this.doLoad()
                    }
                })
        },
        doChangeExer(item) {
            this.$http
                .post('/cts/ate/device/mgr/exer/change', {
                    id: item.id,
                    flag: !item.exer
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('设置成功')
                        this.doLoad()
                    }
                })
        },
        doChangeExam(item) {
            this.$http
                .post('/cts/ate/device/mgr/exam/change', {
                    id: item.id,
                    flag: !item.exam
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('设置成功')
                        this.doLoad()
                    }
                })
        },
        doUnbindUnit(did, unit) {
            this.$http
                .post('/cts/ate/device/mgr/unit/set', {
                    id: did,
                    unit: unit,
                    flag: false
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('解绑成功')
                        this.doLoad()
                    }
                })
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selRows = selectedRows
        },
        onChangePage(page) {
            this.query.page = page
            this.doLoad()
        },
        onChangeSize(page, size) {
            this.query.size = size
            this.query.page = 1
            this.doLoad()
        },
        execQuery() {
            this.query.page = 1
            this.doLoad()
        },
        execReload() {
            this.query = {
                page: 1,
                size: 10,
                time: 0,
                unit: '',
                state: ''
            }
            this.doLoad()
        },
        showAuditForm(item) {
            this.now = item
            this.form = true
        },
        execDelete() {
            let names = []
            let ids = []
            this.selRows.forEach(row => {
                names.push(row.name)
                ids.push(row.id)
            })
            if (ids.length === 0) {
                this.$message.error('请选择要删除的设备')
                return
            }
            this.$confirm({
                title: '是否删除以下设备？删除后无法恢复。',
                content: '模板：[' + names.join() + ']',
                okText: '确认删除',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                    this.doDelete(ids)
                }
            })
        }
    }
}
</script>
